import * as Sentry from "@sentry/react"
import { startTransition, StrictMode } from "react"
import { hydrateRoot } from "react-dom/client"
import type { ClientOnErrorFunction } from "react-router"
import { HydratedRouter } from "react-router/dom"

if (__SENTRY_DSN__) {
  Sentry.init({
    dsn: __SENTRY_DSN__,
    environment: __SENTRY_ENV__,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false
  })
}

const onError: ClientOnErrorFunction = (error) => {
  Sentry.captureException(error)
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter onError={onError} />
    </StrictMode>
  )
})

declare const __SENTRY_DSN__: string | undefined
declare const __SENTRY_ENV__: string | undefined
